module.exports = __webpack_public_path__ + "images/yandex_zen.c469e53c05d4c7b33ffb93a1bf1f43bd.svg";